import React from 'react';
import { flowRight } from 'lodash';
import withHTMLHeadSEO from '../../hocs/with-html-head-seo/withHTMLHeadSEO.hoc';
import withRemediationBase from '../../hocs/with-remediation-base/withRemediationBase.hoc';
import RemediationAssignment from './RemediationAssignment.component';

import { RecordEmpty } from '../../models/common.models';

export const RemediationStudentHomeComponent = (): JSX.Element => {
  return (
    <RemediationAssignment />
  );
};

const enhance = flowRight(
  withHTMLHeadSEO({ title: 'Remediation' }),
  withRemediationBase(),
);

const RemediationStudentHome = enhance(RemediationStudentHomeComponent) as React.FC<RecordEmpty>;

export default RemediationStudentHome;
